<template>
	<ul class="stars-wrapper">
		<li v-for="(star, index) in stars" :key="star" :class="['star', { filled: fillStar(index) }]">
			<svg viewBox="0 0 24.75 23.72" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="fill" d="M24.75 8.69l-6.05 6.15 1.68 8.62-7.76-3.91-7.47 4.18 1.29-8.56L0 9.28l8.55-1.46L12.24 0l3.96 7.76z" fill="#ad7330"/><path class="empty" d="M12.36 7.73l.81 1.58L14 11l1.84.2 1.55.17-1.12 1.14L15 13.73l.34 1.76.35 1.8-1.56-.78-1.61-.81-1.52.88-1.41.78.26-1.68.27-1.8-1.38-1.22-1.3-1.19 1.68-.29 1.76-.29.76-1.61zM12.24 0L8.55 7.82 0 9.28l6.44 5.89-1.29 8.56 7.47-4.18 7.76 3.91-1.68-8.62 6.05-6.15-8.55-.93z" fill="#ad7330"/></svg>
		</li>
	</ul>
</template>

<script>
export default {
	name: 'StarRating',
	props: {
		stars: {
			type: Number,
			required: false,
			default: 5,
		},
		fillCount: {
			type: Number,
			required: true,
		},
	},
	methods: {
		fillStar(index) {
			return index < this.fillCount;
		},
	},
};
</script>

<style lang="scss" scoped>
	.stars-wrapper {
		width: 50%;
		display: inline-flex;
	}

	.star {
		height: 100%;
		width: 100%;
		max-width: 25px;
		&:not(.filled) .fill { display: none; }
	}
</style>



// WEBPACK FOOTER //
// src/components/base/StarRating.vue